/*
  Product trust services
*/
(function () {
  const defaultOptions = {
    minDays: 5,
    maxDays: 12,
    timeZone: 'Asia/Tokyo'
  }

  const getInteger = (value, fallback) => {
    const parsed = Number.parseInt(value, 10)
    return Number.isFinite(parsed) ? parsed : fallback
  }

  const getZonedDateParts = (date, timeZone) => {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone,
      year: 'numeric',
      month: 'numeric',
      day: 'numeric'
    }).formatToParts(date)

    return {
      year: Number(parts.find(part => part.type === 'year')?.value),
      month: Number(parts.find(part => part.type === 'month')?.value),
      day: Number(parts.find(part => part.type === 'day')?.value)
    }
  }

  const addCalendarDays = (dateParts, days) => {
    const date = new Date(Date.UTC(
      dateParts.year,
      dateParts.month - 1,
      dateParts.day + days
    ))

    return {
      year: date.getUTCFullYear(),
      month: date.getUTCMonth() + 1,
      day: date.getUTCDate()
    }
  }

  const formatDatePart = (dateParts, includeYear = false) => (
    `${includeYear ? `${dateParts.year}年` : ''}${dateParts.month}月${dateParts.day}日`
  )

  const getDeliveryRangeText = (date = new Date(), options = {}) => {
    const minDays = getInteger(options.minDays, defaultOptions.minDays)
    const maxDays = getInteger(options.maxDays, defaultOptions.maxDays)
    const timeZone = options.timeZone || defaultOptions.timeZone
    const baseDateParts = getZonedDateParts(date, timeZone)
    const startDateParts = addCalendarDays(baseDateParts, minDays)
    const endDateParts = addCalendarDays(baseDateParts, maxDays)
    const showYear = startDateParts.year !== endDateParts.year
    const startText = formatDatePart(startDateParts, showYear)
    const endText = startDateParts.month === endDateParts.month && !showYear
      ? `${endDateParts.day}日`
      : formatDatePart(endDateParts, showYear)

    return `${startText}〜${endText}頃お届け予定`
  }

  const updateDeliveryText = (root = document) => {
    root.querySelectorAll('[data-buy-delivery-note], [data-product-trust-delivery-window]').forEach((element) => {
      const text = getDeliveryRangeText(new Date(), {
        minDays: element.dataset.deliveryMinDays,
        maxDays: element.dataset.deliveryMaxDays,
        timeZone: element.dataset.deliveryTimeZone
      })

      element.textContent = `${element.dataset.deliveryPrefix || ''}${text}`
    })
  }

  const setActiveTeaser = (items, activeIndex) => {
    items.forEach((item, index) => {
      const isActive = index === activeIndex
      item.classList.toggle('is-active', isActive)
      item.setAttribute('aria-hidden', isActive ? 'false' : 'true')
    })
  }

  const initTrustService = (container) => {
    if (container.dataset.productTrustInitialized === 'true') return

    const toggle = container.querySelector('[data-product-trust-toggle]')
    const details = container.querySelector('[data-product-trust-details]')
    const teaserItems = [...container.querySelectorAll('[data-product-trust-teaser-item]')]

    if (!toggle || !details || teaserItems.length === 0) return

    container.dataset.productTrustInitialized = 'true'

    let activeIndex = teaserItems.findIndex(item => item.classList.contains('is-active'))
    let rotateTimer = null
    activeIndex = activeIndex >= 0 ? activeIndex : 0
    setActiveTeaser(teaserItems, activeIndex)

    const isExpanded = () => toggle.getAttribute('aria-expanded') === 'true'

    const stopRotation = () => {
      if (!rotateTimer) return
      window.clearInterval(rotateTimer)
      rotateTimer = null
    }

    const startRotation = () => {
      if (rotateTimer || teaserItems.length < 2 || isExpanded()) return

      rotateTimer = window.setInterval(() => {
        activeIndex = (activeIndex + 1) % teaserItems.length
        setActiveTeaser(teaserItems, activeIndex)
      }, 3800)
    }

    toggle.addEventListener('click', () => {
      const nextExpanded = !isExpanded()
      toggle.setAttribute('aria-expanded', String(nextExpanded))
      container.classList.toggle('is-expanded', nextExpanded)
      details.hidden = !nextExpanded

      if (nextExpanded) {
        stopRotation()
      } else {
        startRotation()
      }
    })

    startRotation()
  }

  const init = (root = document) => {
    updateDeliveryText(root)
    root.querySelectorAll('[data-product-trust-services]').forEach(initTrustService)
  }

  window.ProductTrustServices = Object.assign(window.ProductTrustServices || {}, {
    getDeliveryRangeText,
    init,
    updateDeliveryText
  })

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document))
  } else {
    init(document)
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target)
  })
})()
